import { type ReactNode } from 'react';
import styles from './VisuallyHidden.module.css';

type Props = {
  children: ReactNode;
};

export function VisuallyHidden({ children }: Props) {
  return <span className={styles.root}>{children}</span>;
}
